/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Schema for filter definition rule labels
 */
export var FilterDefinitionRuleLabel;
(function (FilterDefinitionRuleLabel) {
  FilterDefinitionRuleLabel['REQUIRED'] = 'REQUIRED';
  FilterDefinitionRuleLabel['MIN'] = 'MIN';
  FilterDefinitionRuleLabel['MAX'] = 'MAX';
  FilterDefinitionRuleLabel['NOT_AFTER_END_OF'] = 'NOT_AFTER_END_OF';
})(FilterDefinitionRuleLabel || (FilterDefinitionRuleLabel = {}));
